<template>
  <div>
    <el-select
      v-model="areaSelectInfo.selectProv"
      placeholder="请选择省"
      style="width: 100%"
      @change="getProv"
    >
      <el-option
        v-for="item in areaSelectInfo.provs"
        :key="item.areaCode"
        :label="item.areaName"
        :value="item.areaCode"
      ></el-option>
    </el-select>

    <el-select
      v-model="areaSelectInfo.selectCity"
      placeholder="请选择城市"
      style="width: 100%"
      @change="getCity"
      :disabled="!areaSelectInfo.selectProv"
    >
      <el-option
        v-for="item in areaSelectInfo.citys"
        :key="item.areaCode"
        :label="item.areaName"
        :value="item.areaCode"
      ></el-option>
    </el-select>

    <el-select
      v-model="areaSelectInfo.selectArea"
      placeholder="请选择区县"
      style="width: 100%"
      @change="getArea"
      :disabled="!areaSelectInfo.selectCity"
    >
      <el-option
        v-for="item in areaSelectInfo.areas"
        :key="item.areaCode"
        :label="item.areaName"
        :value="item.areaCode"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import { getAreas } from '@/api/common/communityManage/communityManageApi'

export default {
  name: 'AreaSelect',
  props: {
    callBackListener: String,
    callBackFunction: String,
    namespace: String
  },
  data() {
    return {
      areaSelectInfo: {
        areas: [],
        provs: [],
        citys: [],
        allCity: [],
        selectProv: '',
        selectProvName: '',
        selectCity: '',
        selectCityName: '',
        selectArea: '',
        selectAreaName: ''
      }
    }
  },
  created() {
    this._initArea('101', '0')
  },
  methods: {
    getProv(prov) {
      this.areaSelectInfo.selectCity = ''
      this.areaSelectInfo.selectArea = ''
      this._initArea('202', prov)
    },
    getCity(city) {
      this.areaSelectInfo.selectArea = ''
      this._initArea('303', city)
    },
    getArea(area) {
      this.areaSelectInfo.cityCode = area

      this.areaSelectInfo.areaAddress = ''
      if (this.areaSelectInfo.provs == null || this.areaSelectInfo.provs == undefined) {
        return
      }

      this.areaSelectInfo.provs.forEach(param => {
        if (param.areaCode == this.areaSelectInfo.selectProv) {
          this.areaSelectInfo.selectProvName = param.areaName
        }
      })

      this.areaSelectInfo.citys.forEach(param => {
        if (param.areaCode == this.areaSelectInfo.selectCity) {
          this.areaSelectInfo.selectCityName = param.areaName
        }
      })

      this.areaSelectInfo.areas.forEach(param => {
        if (param.areaCode == this.areaSelectInfo.selectArea) {
          this.areaSelectInfo.selectAreaName = param.areaName
        }
      })

      this.$emit('notifyArea', {
        selectProv: this.areaSelectInfo.selectProv,
        selectProvName: this.areaSelectInfo.selectProvName,
        selectCity: this.areaSelectInfo.selectCity,
        selectCityName: this.areaSelectInfo.selectCityName,
        selectArea: this.areaSelectInfo.selectArea,
        selectAreaName: this.areaSelectInfo.selectAreaName
      })
    },
    _initArea(areaLevel, parentAreaCode) {
      getAreas({
        areaLevel,
        parentAreaCode
      }).then(res => {
        const tmpAreas = res
        if (areaLevel == '101') {
          this.areaSelectInfo.provs = tmpAreas
        } else if (areaLevel == '202') {
          this.areaSelectInfo.citys = tmpAreas
        } else {
          this.areaSelectInfo.areas = tmpAreas
        }
      }).catch(error => {
        console.error('请求失败:', error)
        this.$message.error('查询地区失败')
      })
    }
  }
}
</script>

<style scoped>
.el-select {
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>